module.exports = __webpack_public_path__ + "img/logo.23d0207f.png";